module.exports = __webpack_public_path__ + "img/phone_paused.bfc0822a.svg";